import { jobBoardAPI } from './base';

const commentEndpoint = {
  getAll: '/comment',
  create: '/comment',
  getStickyByJob: '/comment/sticky/job',
  getWithRepliesByJob: '/comment/job',
  pinComment: '/comment/pin',
  unpinComment: '/comment/unpin',
  replyComment: '/comment/reply',
  delete: '/comment/{id}'
};

export enum CommentType {
  Field = 'Field',
  Shop = 'Shop',
  All = 'All',
  JobStage = 'JobStage'
}

export interface CreateCommentDTO {
  content: string;
  jobId: string;
  creator: string;
  commentType?: CommentType;
  isSticky?: boolean;
  mentionedUsers?: string[];
}

interface ReplyCommentDTO {
  content: string;
  creator: string;
  mentionedUsers?: string[];
  parentCommentId: string;
}

export interface Comment {
  content: string;
  jobId: string;
  creator: string;
  isSticky?: boolean;
}

export const CREATE_COMMENT = (data: CreateCommentDTO) => {
  return jobBoardAPI.post(commentEndpoint.create, data);
};

export const GET_ALL_COMMENTS = async (): Promise<Comment> => {
  return (await jobBoardAPI.get(commentEndpoint.getAll)).data;
};

export const GET_COMMENTS_WITH_REPLIES_BY_JOB = async (
  jobId: string
): Promise<any> => {
  return (
    await jobBoardAPI.get(
      `${commentEndpoint.getWithRepliesByJob}/${jobId}/flat`
    )
  ).data;
};

export const GET_STICKY_COMMENTS_BY_JOB = async (
  jobId: string
): Promise<any> => {
  return (await jobBoardAPI.get(`${commentEndpoint.getStickyByJob}/${jobId}`))
    .data;
};

export const PIN_COMMENT = async (commentId: string) => {
  return (await jobBoardAPI.patch(`${commentEndpoint.pinComment}/${commentId}`))
    .data;
};

export const UNPIN_COMMENT = async (commentId: string) => {
  return (
    await jobBoardAPI.patch(`${commentEndpoint.unpinComment}/${commentId}`)
  ).data;
};

export const REPLY_COMMENT = async (data: ReplyCommentDTO) => {
  return (await jobBoardAPI.post(commentEndpoint.replyComment, data)).data;
};

export const DELETE_COMMENT = async (commentId: string) => {
  return (
    await jobBoardAPI.delete(
      `${commentEndpoint.delete.replace('{id}', commentId)}`
    )
  ).data;
};
